import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { pathOr } from 'ramda'
import { chatbotEvents } from '../state'
import { portfolioApiEvents } from 'modules/api/portfolio'

export interface OwnerDetailsState {
  selectedParty: string | null
}

export const initialState: OwnerDetailsState = {
  selectedParty: null,
}

const ownerDetailsSlice = createSlice({
  name: 'chatbot/dialogs/ownerDetails',
  initialState,
  reducers: {
    partySelected: (state, action: PayloadAction<{ id: string }>) => {
      state.selectedParty = action.payload.id
    },
    partySaved: (state, action: PayloadAction<{ id: string }>) => {
      state.selectedParty = action.payload.id
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        state.selectedParty = pathOr(null, ['parties', 'owners', 'primary', 'partyId'], action.payload)
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, state => {
        state.selectedParty = null
      })
      .addCase(portfolioApiEvents.updateOwnerParties_success, (state, action) => {
        state.selectedParty = action.payload.parties?.owners?.primary?.partyId ?? null
      })
  },
})

export const { reducer } = ownerDetailsSlice
export const ownerDetailsEvents = ownerDetailsSlice.actions
